const images = require.context('../images', true)

export default function imagePath (name) {
  return images(name, true)
}
